import { PaginatedTable } from 'core/table';
import type { FetcherOptions } from 'hooks/usePaginatedData';
import { useResponsive } from 'hooks/useResponsive';
import { PathologyApi } from 'integration/aggregate';
import type React from 'react';

import { getDataFromResponse, serviceRequestColumns } from './columns';

interface ServiceRequestListProps {
  patientId: string;
}

const api = new PathologyApi();

export const ServiceRequestList: React.FC<ServiceRequestListProps> = ({
  patientId,
}) => {
  const showHeader = useResponsive({ md: true }, false);
  const isStriped = useResponsive({ md: true }, false);

  const fetcher = (options?: FetcherOptions) =>
    api.getPathologyOrders({
      subject: patientId,
      pageToken: options?.nextToken,
      ...options,
    });

  const cacheKey = JSON.stringify({
    subject: patientId,
  });

  return (
    <PaginatedTable
      cacheKey={`ServiceRequest${cacheKey}`}
      fetcher={fetcher}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      columns={serviceRequestColumns}
      showHeader={showHeader}
      isStriped={isStriped}
      getDataFromResponse={getDataFromResponse}
    />
  );
};
